import { DialogService, GridAction } from '@eforall/dashboard';
import { EventSummary } from '@interfaces';
import { EventDialog } from '../../../../../../../ui/widget';
import { AccClassEventsViewerDialogDataService } from '../acc-class-events-viewer-dialog-data.service';

export function getActions(dialogDataService: AccClassEventsViewerDialogDataService, dialogService: DialogService) {

	const actions: GridAction<EventSummary>[] = [
		{
			iconClass: 'fa-regular fa-calendar-lines',
			label: 'Open Event',
			isEnabled: rows => !!rows.length,
			execute: async rows => {
				const eventId = rows[0]?.eventId;
				if (eventId) {
					await dialogService.showCustom(EventDialog, { data: { eventId } }, 900, 700);
					await dialogDataService.getClassEventsSummary(rows[0]!.accId);
				}
			}
		},
	];

	return actions;
}